export default "__VITE_ASSET__D7T1liUC__"